// removed by extract-text-webpack-plugin
module.exports = {"button":"_2K25j","wrapper":"_336sV","label":"_36b0R"};


//////////////////
// WEBPACK FOOTER
// ./app/components/header-back-button/header-back-button.scss
// module id = 1575
// module chunks = 0